import { useQuery } from '@tanstack/react-query';
import { fetchMinerHardware, type HardwareResponse } from '../lib/minerApi.js';

export function useMinerHardware(address: string | null) {
  return useQuery<HardwareResponse | null>({
    queryKey: ['miner-hardware', address],
    queryFn: async () => {
      if (!address) return null;
      return fetchMinerHardware(address);
    },
    enabled: !!address,
    staleTime: 60_000,
    retry: 1,
  });
}
